<div class="modal-header">
  <button
    type="button"
    (click)="dismiss()"
    class="btn-close"
    title="Close"></button>
  <h3 class="modal-title">Import data</h3>
</div>
<div>
  <div class="modal-body clearfix">
    <div class="col-lg-12">
      <h4>Selected Files:</h4>
      <ul>
        <li *ngFor="let file of files">{{ file.name }}</li>
      </ul>
      <label class="btn btn-primary" style="margin: 10px 0">
        <input
          type="file"
          (change)="filesChange($event)"
          accept="application/json"
          style="display: none"
          multiple />
        <span class="fa fa-upload"></span>
        &nbsp;Upload Files
      </label>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button (click)="import()" class="btn btn-primary">Import</button>
  <button (click)="dismiss()" class="btn btn-danger">Cancel</button>
</div>
